module.exports = __webpack_public_path__ + "images/emoji/cupid.d14af33f0209788725ba.png";